goog.provide("shadow.js.shim.module$$mui$material$Slider$default");
shadow.js.shim.module$$mui$material$Slider$default = shadow.js.shim.module$$mui$material$Slider.default;
